// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"d0bee2fa","703":"ae9d3633"}[chunkId] + ".chunk.js";
};